import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';

@Injectable({
  providedIn: 'root'
})
export class ShiftTenementsService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initShiftTenementsForm() {
    return this.httpClient.get<{
      lotteryList: {[key: number]: string}, 
      applicationSummaryReportKey: number, 
      status: string, 
      errorMessage: string
    }>(ApiUrls.shiftTenementsInitFormUrl);
  }

  fetchShiftTenementStatusForLottery(lotteryKey: number) {
    return this.httpClient.get<{
      shiftTenementStatus: string,
      status: string, 
      errorMessage: string
    }>(ApiUrls.fetchShiftTenementStatusForLotteryUrl.replace('{lotteryKey}', lotteryKey?.toString()));
  }

  shiftTenementStatusForLottery(lotteryKey: number) {
    return this.httpClient.post<{
      status: string, 
      errorMessage: string
    }>(ApiUrls.shiftTenementForLotteryUrl.replace('{lotteryKey}', lotteryKey?.toString()), null);
  }

  approveShiftTenementStatusForLottery(lotteryKey: number) {
    return this.httpClient.post<{
      status: string, 
      errorMessage: string
    }>(ApiUrls.approveShiftTenementStatusForLotteryUrl.replace('{lotteryKey}', lotteryKey?.toString()), null);
  }

  generateShiftingTenementSummary(lotteryKey: number) {
    return this.httpClient.get<{lst: {[key: string]: string}[], title: string, columnNames: string[],
    columnWidths: string, status: string, errorMessage: string, generatedBy: string, generatedOn: string}>(
      ApiUrls.generateShiftingTenementSummaryUrl.replace('{lotteryKey}', lotteryKey.toString()));
  }
  
  generateReport(selectedReport: number, dependencies: {lotteryKey: number}) {
    return this.httpClient.post<FileResponseModel>(ApiUrls.generateReportUrl.replace('{selectedReport}', selectedReport.toString()), dependencies);
  }
  
  fetchQueryExecutorReport(selectedReport: number) {
    return this.httpClient.get<{lst: {[key: string]: string}[], title: string, columnNames: string[],
    columnWidths: string, status: string, errorMessage: string, generatedBy: string, generatedOn: string}>(ApiUrls.queryExecutorReportUrl.replace('{selectedReport}', selectedReport.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
